import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { FileService } from 'src/app/service/util/file.service';
import { LanguageService } from '../language/language.service';

export interface CameraOptions {
  promptLabelHeader?:string,
  promptLabelCancel?:string,
  promptLabelPhoto?:string,
  promptLabelPicture?:string,
  width?:number,
  height?:number
}

@Injectable({
  providedIn: 'root'
})
export class CameraService {

  constructor(
    private file: FileService,
    private lang: LanguageService
  ) { }

  async getPhoto(opts?:CameraOptions) {
    opts = {
      promptLabelHeader: opts?.promptLabelHeader || this.lang.selected.guide.imageSelect,
      promptLabelCancel: opts?.promptLabelCancel || "취소",
      promptLabelPhoto: opts?.promptLabelPhoto || this.lang.selected.guide.album,
      promptLabelPicture: opts?.promptLabelPicture || this.lang.selected.guide.camera,
      width: opts?.width,
      height: opts?.height
    }
    const photo = await Camera.getPhoto({
      resultType: CameraResultType.DataUrl,
      ...opts,
      source: CameraSource.Prompt
    });
    let dataUrl:string;
    if(opts?.width && opts?.height) {
      dataUrl = await this.file.cutImage(photo.dataUrl, {
        width: opts.width,
        height: opts.height
      });
    } else {
      dataUrl = photo.dataUrl;
    }
    const blob = await this.file.dataUrlToBlob(dataUrl);
    return blob;
  }
}